/*
 * @Author: edvardchen
 * @Date:   2016-11-14 12:11:15
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-24 11:14:31
 */
// @ flow
import _ from 'lodash';
import qs from 'query-string';
import isomorphicConfig from './isomorphicConfig';
import urlUtil from './url';
import { startQbDownLoadForShare, cancelQbDownLoadForShare, tbsRunApp, isInstalled } from './QBDownloadForShare';
import track from './track';
import { isTBS, isAndroid, isQQBrowser } from './UA';
import isFeedsFast from './isFeedsFast';
import { sharelpModal } from '../actions/installer';

import { isLoadKuaiBao } from './PageConfigDataForShare';

let reportToShareCenter;
if (__CLIENT__) {
  reportToShareCenter = require('./reportToShareCenter').default;
}

export const loadStatus = {
  DEFAULT: 0,
  LOADING: 1,
  LOADED: 2,
  INSTALLED: 3,
};

const config = {};

export const setConfig = (data) => Object.assign(config, data);

/**
 * 异步加载脚本
 * @return {Promise}
 */
function qLoadScript() {
  if (__SERVER__) {
    throw new Error("don't run x5_sahre on server-side.Check your code please!");
  }
  return new Promise((resolve, reject) => {
    if (__CLIENT__) {
      require.ensure(['scriptjs'], (require) => {
        const scriptjs = require('scriptjs');
        scriptjs(isomorphicConfig.x5share, resolve);
        isomorphicConfig.x5_openqb && scriptjs(isomorphicConfig.x5_openqb, resolve);
        isomorphicConfig.trackbundle && scriptjs(isomorphicConfig.trackbundle, resolve);
        isomorphicConfig.tbs && scriptjs(isomorphicConfig.tbs, resolve);
        isomorphicConfig.Clipper && scriptjs(isomorphicConfig.Clipper, resolve);
      });
    } else {
      reject(new Error('How to download QB on server? Hmm? '));
    }
  });
}

const delayExecFnc = (fncPath, callback, errorCallback) => {
  if (!fncPath) {
    return;
  }
  const checkApi = _.get(window, fncPath);
  const isAbleCheck = checkApi && typeof checkApi === 'function';
  if (isAbleCheck) {
    callback && callback();
  } else {
    let isExecute = false;
    const nowT = new Date();
    const timer = setInterval(() => {
      if (isAbleCheck && !isExecute) {
        callback && callback();
        isExecute = true;
        clearInterval(timer);
      }
      if (new Date() - nowT > 3000) {
        errorCallback && errorCallback();
        clearInterval(timer);
      }
    }, 100);
  }
};

export function isBaiPai() {
  const href = window.location.href || '';
  return (
    (isAndroid(window.navigator.userAgent) && isQQBrowser(window.navigator.userAgent) && /source=baipai/.test(href)) ||
    false
  ); // 白牌合作商拉新统计
}

const checkQB = (fn, isFF) => {
  const ckFn = isFF ? 'checkFF' : 'checkQB';
  console.log(`极速版checkQB===${ckFn}`);
  window.SQB[ckFn]((data) => {
    // const ret = !((!data && window.SQB.Detect && window.SQB.Detect.isAndroid));
    const ret = window.SQB.Detect && window.SQB.Detect.isAndroid ? !!data : false;
    fn(ret);
  });
};
// 只统计Android的未装机量
export function checkAndroidQB(fn) {
  const isFF = isFeedsFast();
  const sqbName = isFF ? 'SQB.checkFF' : 'SQB.checkQB';
  return qLoadScript().then(() => {
    delayExecFnc(sqbName, () => {
      checkQB(fn, isFF);
    });
  });
}

let currStatus;
/**
 * 获取 QB 安装下载状态
 * @return {Promise}
 */
export function detectStatus() {
  // if (typeof currStatus !== 'undefined') {
  //   return Promise.resolve(currStatus);
  // }

  return qLoadScript()
    .then(
      () =>
        new Promise((resolve) => {
          const isInstall = _.get(global, 'SQB.isInstall');
          if (isInstall && typeof isInstall === 'function') {
            isInstall(resolve); // check if QB has been installed
          }
        }),
    )
    .then((installed) => {
      if (installed) {
        return loadStatus.INSTALLED;
      }
      return new Promise((resolve) => {
        const isDownload = _.get(global, 'SQB.isDownload');
        if (isDownload && typeof isDownload === 'function') {
          isDownload({
            androidUrl: config.androidUrl,
            success: (finished) => {
              if (finished) {
                resolve(loadStatus.LOADED);
                return;
              }
              resolve(loadStatus.DEFAULT);
            },
          }); // check if QB has been installed
        }
      });
    })
    .then((result) => {
      currStatus = result; // cache
      let ret = result;
      if (isBaiPai()) {
        // 白牌处理
        if (typeof window !== 'undefined') {
          const isInstallApk = _.get(window, 'browser.app.isInstallApk');
          isInstallApk &&
            isInstallApk(
              (resp) => {
                ret = resp ? loadStatus.INSTALLED : result;
              },
              { packagename: 'com.tencent.mtt' },
            );
        }
      } else if (isFeedsFast()) {
        // 极速版
        if (typeof window !== 'undefined') {
          return new Promise((resolve) => {
            checkAndroidQB((ffresult) => {
              console.log('ffresult============', ffresult);
              if (ffresult) {
                resolve(loadStatus.INSTALLED);
                ret = loadStatus.INSTALLED;
              }
            });
          });
        }
      } else if (isLoadKuaiBao()) {
        // 天天快报
        if (typeof window !== 'undefined') {
          return new Promise((resolve) => {
            if (isInstalled()) {
              resolve(loadStatus.INSTALLED);
              ret = loadStatus.INSTALLED;
            }
          });
        }
      }
      console.log('detectStatus===isFeedsFast==outer==ret==', ret);
      return ret;
    });
}

export function isQBInstalled() {
  return currStatus === loadStatus.INSTALLED;
}

const shareLog = (action, label) => {
  track({
    location: 'share',
    action,
    object: label,
  });
  reportToShareCenter(action);
};

function openQb({ url, label }) {
  shareLog('relive', label);
  let finalUrl = url || config.openUrl || window.location.href;
  if (isAndroid(window.navigator.userAgent)) {
    finalUrl = `${finalUrl},backurl=qb://home/feeds?tab=1`;
  } else {
    finalUrl = `${finalUrl},backurl=qb://home/feeds?tabId=1`;
  }
  if (isBaiPai() && typeof window !== 'undefined') {
    // 目前这个方法只能拉起qb没办法打开指定页面，9.3之后可以通过新的scheme来用loadUrl用qb打开指定页面
    const runApk = _.get(window, 'browser.app.runApk');
    const showAlertDialog = _.get(window, 'browser.app.showAlertDialog');
    const copy = _.get(window, 'browser.device.copy') || false;
    if (runApk && showAlertDialog) {
      const showCallback = () => {
        showAlertDialog(
          (res) => {
            if (res && res.result === 1) {
              runApk('com.tencent.mtt');
            } else if (res && res.result === 0) {
              console.log('取消');
            } else {
              console.log('参数错误');
            }
          },
          {
            title: '',
            content: '请打开QQ浏览器地址框点击粘贴',
            cancel: '取消',
            confirm: '确定',
          },
        );
      };
      if (copy) {
        copy(finalUrl, () => {
          setTimeout(() => {
            showCallback();
          }, 1300);
        });
      } else {
        showCallback();
      }
    }
    return;
  }
  const isFF = isFeedsFast();
  if (isFF && window.SQB.openFF) {
    console.log(`极速版===${finalUrl}`);
    window.SQB.openFF({
      url: finalUrl,
    });
    return;
  }
  // android和tbs环境，使用tbs接口的拉活
  if (isAndroid(window.navigator.userAgent) && isTBS(window.navigator.userAgent) && window.tbs) {
    if (finalUrl) {
      window.localStorage.setItem('URL_FOR_SHARE', finalUrl);
    }

    track({
      location: 'sharelp',
      action: 'click',
      object: 'sharelp_run_app',
    });

    tbsRunApp();
  } else {
    window.SQB.openQb({
      url: finalUrl,
    });
  }
}

function install() {
  window.SQB.installQb({
    androidUrl: config.androidUrl,
  });
}

export { shareLog, openQb, install, cancelQbDownLoadForShare };

// let qDownloading;
// let progressCallbacks = [];
/**
 * 下载
 * 避免重复下载
 * @param  {Function} options.progress
 * @return {Promise}
 */
export function download({ label, dispatchFunc, url }) {
  const isFF = isFeedsFast();
  // android手机并且支持TBS下载，走此分支
  if (isAndroid(window.navigator.userAgent) && isTBS(window.navigator.userAgent) && window.tbs) {
    startQbDownLoadForShare(dispatchFunc, url);
  } else {
    // android用微信api下载
    if (
      window.SQB &&
      window.SQB.Detect &&
      window.SQB.Detect.isWX &&
      window.SQB.Detect.isAndroid &&
      window.SQB.wxDownload
    ) {
      const ret = window.SQB.getDownloadUrlAndMd5({
        app: isFF ? 'qbspeed' : 'qqbrowser',
        channel: isFF ? '11707' : '10817',
      });
      console.log(ret);
      if (ret && ret.path && ret.md5) {
        const options = {
          taskName: isFF ? '天天快报极速版-腾讯王卡,全网免流量' : 'QQ浏览器-腾讯王卡,全网免流量',
          apkUrl: ret.path,
          apkMd5: ret.md5,
          logo: isFF
            ? 'http://res.imtt.qq.com/tagapp/qbfflogo.png'
            : 'http://res.imtt.qq.com/tagapp/qblogo_android_512.png',
        };
        window.SQB.wxDownload(options);
        return;
      }
    }
    shareLog('renew', label);
    const href = window.location.href || '';
    let channel = isFF ? '11707' : '10817';
    if (isBaiPai() && (/&ch=/.test(href) || /\?ch=/.test(href))) {
      // 白牌合作商拉新统计
      // channel = qs.parse(href).ch || channel;
      channel = '11509'; // 产品后来要求固定这个先
      const jsDownload = _.get(window, 'browser.download');
      if (jsDownload && jsDownload.getDownloadStatus && jsDownload.startDownload) {
        const downloadUrl = `https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=${channel}`;
        const status = jsDownload.getDownloadStatus({ url: downloadUrl });
        const toast = _.get(window, 'browser.app.toast');
        if (status === 'TASK_STATUS_NONE') {
          jsDownload.startDownload({
            url: downloadUrl,
            filename: 'QQ浏览器.apk',
            needdialog: 'false',
            neednotification: 'true',
            needtoast: 'false',
          });
          toast && toast('已加入任务，请等待安装~');
        } else if (status === 'TASK_STATUS_COMPLETED') {
          jsDownload.installApp({
            url: downloadUrl,
            checkpolicy: 2,
          });
        } else if (status === 'TASK_STATUS_PROGRESS') {
          toast && toast('还在下载中，请等待安装~');
        }
        return;
      }
    }
    if (isFF && window.SQB.Detect && window.SQB.Detect.isIos && window.SQB.checkQB) {
      // 极速版目前不支持iOS，弹框根据用户选择跳转
      dispatchFunc(sharelpModal(true)); // 显示弹框
      return;
    }
    window.location.href = isFF
      ? `https://mdc.html5.qq.com/directdown?app=qbspeed&channel=${channel}`
      : `https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=${channel}`;
  }
}

// 用qb打开或是下载【iOS不支持极速版】
export function downloadOrOpenQb(url) {
  window.SQB.checkQB((ret) => {
    if (ret) {
      let finalUrl = url || config.openUrl || window.location.href;
      finalUrl = `${finalUrl},backurl=qb://home/feeds?tabId=1`;
      window.SQB.openQb({
        url: finalUrl,
      });
    } else {
      window.location.href = 'https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=10817';
    }
  });
}

function shareInfoReport(message: string, key?: string) {
  const body = {
    message,
    logName: 'shareLog',
    key: key || message,
  };
  new window.Image().src = `${isomorphicConfig.newsHost || ''}/api/logReport?__=${window.btoa(qs.stringify(body))}`;
}
// 设置分享信息
export function onShare({ sTitle, sSummary, sPicUrl, openUrl }) {
  if (openUrl) {
    setConfig({ openUrl });
  }
  const shareConfig = _.get(isomorphicConfig, 'share') || {};
  const { summary, thumb } = shareConfig.card || {};
  const info = {
    sTitle,
    sSummary: sSummary || summary,
    sPicUrl: sPicUrl || thumb,
  };
  const { appId } = shareConfig;
  return qLoadScript()
    .then(() => {
      // 分享计数
      const urlObj = urlUtil.parseUrl(window.location.href);
      const currShareCount = Number(urlObj.query.share_count) || 0;
      urlObj.query.share_count = currShareCount + 1;
      const sShareUrl = urlUtil.formatUrl(urlObj);
      console.log('before setShareInfo', sShareUrl, info);
      info.sShareUrl = sShareUrl;
      // 前端设置分享信息
      delayExecFnc('SQB.onShare', () => {
        window.SQB.onShare(
          {
            appId,
            isShowBanner: false,
            sShareUrl,
            ...info,
          },
          () => {
            shareInfoReport('setShareInfoTimeOut');
          },
        );
      });
      Object.keys(info).forEach((key) => {
        if (key && !info[key]) {
          shareInfoReport(`shareInfo${key}IsNull`);
        }
      });
    })
    .catch((e) => {
      console.log('shareLoadScriptError', e);
      shareInfoReport('shareLoadScriptError');
    });
}

const addSharePowerLog = () => {
  if (window.SQB.Detect && (window.SQB.Detect.isAndroid || window.SQB.Detect.isIos || window.SQB.Detect.isMiniQB))
    return;
  track({
    location: 'sharelp',
    action: 'exposure',
    object: 'sharelp_powerPC',
  });
};

// 设置分享信息
export function addSharePower({ sType, sId, subjectId }) {
  return qLoadScript().then(() => {
    console.log('addShareValue ==', sType, sId, subjectId);
    delayExecFnc('SQB.addSharePower', () => {
      window.SQB.addSharePower({ sType, sId, subjectId });
      addSharePowerLog();
    });
  });
}

if (__CLIENT__) {
  // init
  const shareConfig = _.get(isomorphicConfig, 'share');
  setConfig(shareConfig.download);
}
